module.exports = __webpack_public_path__ + "static/img/yytx41.53f8bb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx41.png
// module id = 908
// module chunks = 0